const findValueFromCookie = (key) => {
  const cookie = document.cookie;

  const keyValues = cookie.split(';').map((item) => {
    const array = item.split('=');
    return array.length ? { key: array[0].trim(), value: array[1] } : { key: undefined, value: undefined };
  });

  const target = keyValues.find((obj) => {
    return obj.key === key;
  });

  return target && target.value;
};

export const getSiteId = () => {
  return findValueFromCookie('SITE_ID');
};

export const getOtherSiteId = () => {
  return findValueFromCookie('OTHER_SITE_ID');
};

export const getCouponInfoFromCookie = () => {
  const siteId = findValueFromCookie('SITE_ID');
  const discountCode = findValueFromCookie('JP_WARIBIKI_CODE');
  const transactionId = findValueFromCookie('TRANSACTION_ID');

  return { siteId, discountCode, transactionId };
};
